import React, { useState } from "react";
import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalContent,
    Button,
    Input,
} from "@nextui-org/react";
import axios from "axios";
import { toast } from "react-toastify";

const RevertModal = ({ isOpen, onClose, quoteId, accessToken,  onConfirmRevert }) => {
    const [revertReason, setRevertReason] = useState("");
    const [loading, setLoading] = useState(false);

    const handleRevertPayment = async (e) => {
        e.preventDefault();
        if (!revertReason.trim()) return;
        setLoading(true);

        try {
            await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/payment/${quoteId}/status/revert`,
                { reason: revertReason },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            toast.success("Payment reverted successfully!");
            setRevertReason("");
            onClose();
            onConfirmRevert();
            // setTimeout(() => {
            //     window.location.reload();
            // }, 500);
        } catch (error) {
            const errMessage = error?.response?.data?.message || "Something went wrong!";
            toast.error(errMessage);
            // console.log(error?.response?.data?.message)
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal size="sm" isOpen={isOpen} onClose={onClose} className="p-3" placement="center">
            <ModalContent>
                <ModalBody className="flex flex-col items-center space-y-2">
                    <h1 className="font-semibold text-lg">Revert Payment</h1>
                    <hr className="w-full border-gray-300" />
                    <Input
                        label="Reason for Revert"
                        placeholder="Enter reason..."
                        value={revertReason}
                        onChange={(e) => setRevertReason(e.target.value)}
                        fullWidth
                    />
                </ModalBody>
                <ModalFooter className="flex justify-center gap-4">
                    <Button color="danger" variant="light" onPress={onClose} disabled={loading}>
                        Cancel
                    </Button>

                    <Button
                        type="button"
                        color={revertReason.trim().length === 0 ? "default" : "primary"}
                        onClick={handleRevertPayment}
                        disabled={revertReason.trim().length === 0 || loading}
                        isLoading={loading}
        >
                        Confirm Revert
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default RevertModal;
